"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbAuthoriserWithTrustedDevice = exports.MbAuthoriser = void 0;
var features_1 = require("../features");
Object.defineProperty(exports, "MbAuthoriser", { enumerable: true, get: function () { return features_1.MbAuthoriser; } });
Object.defineProperty(exports, "MbAuthoriserWithTrustedDevice", { enumerable: true, get: function () { return features_1.MbAuthoriserWithTrustedDevice; } });
//# sourceMappingURL=authoriser.js.map